/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
export type ProductListItem_product$ref = any;
export type ProductListItem_product = {
    readonly id: string;
    readonly isSubscription: boolean | null;
    readonly productPermissions: ({
        readonly oneCommerce: ({
            readonly preferredCustomer: ({
                readonly view: boolean | null;
                readonly add: boolean | null;
            }) | null;
            readonly default: ({
                readonly view: boolean | null;
                readonly add: boolean | null;
            }) | null;
        }) | null;
    }) | null;
    readonly ranking: number | null;
    readonly company: string | null;
    readonly freeUpsGroundShipping: boolean | null;
    readonly productId: string | null;
    readonly name: string | null;
    readonly category: string | null;
    readonly price: number | null;
    readonly priceUSDmin: number | null;
    readonly priceUSDmax: number | null;
    readonly year: number | null;
    readonly priceSale: number | null;
    readonly reviewAverage: number | null;
    readonly productURLslug: string | null;
    readonly parentProduct: boolean | null;
    readonly inventoryText: string | null;
    readonly reviewTotal: number | null;
    readonly staticUrl: string | null;
    readonly images: ({
        readonly productCatalog: string | null;
        readonly squareFront: string | null;
    }) | null;
    readonly content: ({
        readonly impactSmall: string | null;
        readonly summary: string | null;
    }) | null;
    readonly promoCodeDiscount: ({
        readonly case4Cause: ({
            readonly case12PriceUSD: number | null;
            readonly case6PriceUSD: number | null;
            readonly case6SKU: string | null;
            readonly case12SKU: string | null;
            readonly donationEligible: boolean | null;
        }) | null;
    }) | null;
    readonly inventoryClass: string | null;
    readonly inventorySKU: string | null;
    readonly inventoryQuantity: number | null;
    readonly " $refType": ProductListItem_product$ref;
};



const node: ReaderFragment = (function () {
    var v0 = [
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "view",
            "args": null,
            "storageKey": null
        } as any),
        ({
            "kind": "ScalarField",
            "alias": null,
            "name": "add",
            "args": null,
            "storageKey": null
        } as any)
    ];
    return {
        "kind": "Fragment",
        "name": "ProductListItem_product",
        "type": "Product",
        "metadata": null,
        "argumentDefinitions": [],
        "selections": [
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "priceSale",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "id",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "productPermissions",
                "storageKey": null,
                "args": null,
                "concreteType": "ProductPermissions",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "oneCommerce",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "AppProductPermissionsAccess",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "preferredCustomer",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ProductPermissionsAccess",
                                "plural": false,
                                "selections": (v0 /*: any*/)
                            },
                            {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "default",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "ProductPermissionsAccess",
                                "plural": false,
                                "selections": (v0 /*: any*/)
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "ranking",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "company",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "freeUpsGroundShipping",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "productId",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "name",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "category",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "price",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "priceUSDmin",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "priceUSDmax",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "year",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "isSubscription",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "reviewAverage",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "productURLslug",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "parentProduct",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "inventoryText",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "reviewTotal",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "staticUrl",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "images",
                "storageKey": null,
                "args": null,
                "concreteType": "Images",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "productCatalog",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "squareFront",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "content",
                "storageKey": null,
                "args": null,
                "concreteType": "Content",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "impactSmall",
                        "args": null,
                        "storageKey": null
                    },
                    {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "summary",
                        "args": null,
                        "storageKey": null
                    }
                ]
            },
            {
                "kind": "LinkedField",
                "alias": null,
                "name": "promoCodeDiscount",
                "storageKey": null,
                "args": null,
                "concreteType": "PromoCodeDiscount",
                "plural": false,
                "selections": [
                    {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "case4Cause",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "Case4Cause",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "case12PriceUSD",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "case6PriceUSD",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "case6SKU",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "case12SKU",
                                "args": null,
                                "storageKey": null
                            },
                            {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "donationEligible",
                                "args": null,
                                "storageKey": null
                            }
                        ]
                    }
                ]
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "inventoryClass",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "inventorySKU",
                "args": null,
                "storageKey": null
            },
            {
                "kind": "ScalarField",
                "alias": null,
                "name": "inventoryQuantity",
                "args": null,
                "storageKey": null
            }
        ]
    } as any;
})();
(node as any).hash = '03d0dff490660f0e5dcdd05e69dcfd9f';
export default node;
